/**
 * Lux Announcement Bar
 * - Rotates messages with a soft crossfade (pauses on hover/focus).
 * - Dismiss is remembered per browser session.
 * - Skips rotation timer entirely for reduced-motion users.
 */
(function () {
  'use strict';

  if (customElements.get('lux-announcement-bar')) return;

  class LuxAnnouncementBar extends HTMLElement {
    connectedCallback() {
      this.storageKey = 'lux-announcement-dismissed-' + this.dataset.sectionId;

      try {
        if (sessionStorage.getItem(this.storageKey) === 'true') {
          this.hidden = true;
          return;
        }
      } catch (e) {
        /* sessionStorage unavailable (private mode) — fail open */
      }

      this.messages = Array.from(
        this.querySelectorAll('[data-announcement-message]')
      );
      this.index = 0;
      this.timer = null;

      const dismissBtn = this.querySelector('[data-announcement-dismiss]');
      if (dismissBtn) {
        dismissBtn.addEventListener('click', this.dismiss.bind(this));
      }

      const reducedMotion = window.matchMedia(
        '(prefers-reduced-motion: reduce)'
      ).matches;

      if (
        this.dataset.rotate === 'true' &&
        this.messages.length > 1 &&
        !reducedMotion
      ) {
        this.speed = parseInt(this.dataset.rotateSpeed, 10) || 5000;
        this.start();

        this.addEventListener('mouseenter', this.stop.bind(this));
        this.addEventListener('mouseleave', this.start.bind(this));
        this.addEventListener('focusin', this.stop.bind(this));
        this.addEventListener('focusout', this.start.bind(this));

        document.addEventListener('visibilitychange', () => {
          document.hidden ? this.stop() : this.start();
        });
      }
    }

    disconnectedCallback() {
      this.stop();
    }

    start() {
      if (this.timer) return;
      this.timer = setInterval(this.next.bind(this), this.speed);
    }

    stop() {
      clearInterval(this.timer);
      this.timer = null;
    }

    next() {
      const current = this.messages[this.index];
      this.index = (this.index + 1) % this.messages.length;
      const upcoming = this.messages[this.index];

      current.classList.remove('is-active');
      current.setAttribute('aria-hidden', 'true');
      upcoming.classList.add('is-active');
      upcoming.removeAttribute('aria-hidden');
    }

    dismiss() {
      this.hidden = true;
      this.stop();
      try {
        sessionStorage.setItem(this.storageKey, 'true');
      } catch (e) {
        /* ignore */
      }
    }
  }

  customElements.define('lux-announcement-bar', LuxAnnouncementBar);
})();